import { render, staticRenderFns } from "./reportDataTables.vue?vue&type=template&id=3afa1d68&lang=pug"
import script from "./reportDataTables.vue?vue&type=script&lang=js"
export * from "./reportDataTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports